export default "__VITE_ASSET__DrHmi30i__"